<template>
    <app-primary>
        <template #contentsHead>
            <sub-head-primary itemTitle="사업안내" tabActive="공급안내" bg="/images/sub/business/visual.jpg">
                <template #title>사업안내</template>
            </sub-head-primary>
        </template>

        <page-section-primary titWrapClass="text-center" class="page-section--first page-section--last">
            <template #tit>공급안내</template>

            <sheet-tertiary>
                <v-row class="row--lg" align="center">
                    <v-col cols="auto">
                        <chip-primary class="w-md-140px">공급위치</chip-primary>
                    </v-col>
                    <v-col>
                        <txt-quarternary>서울특별시 성북구 하월곡동 88-222필지 (4호선 미아사거리역 3번출구)</txt-quarternary>
                    </v-col>
                </v-row>
                <v-row class="row--lg mt-0" align="center">
                    <v-col cols="auto">
                        <chip-primary class="w-md-140px">공급규모</chip-primary>
                    </v-col>
                    <v-col>
                        <txt-quarternary>공동주택 지하 2층~지상 최고 27층 1개동 총 299세대 중 민간임대 240세대</txt-quarternary>
                    </v-col>
                </v-row>
                <v-row class="row--lg mt-0" align="center">
                    <v-col cols="auto">
                        <chip-primary class="w-md-140px">공급대상</chip-primary>
                    </v-col>
                    <v-col>
                        <txt-quarternary>민간임대 240세대 (특별공급 48세대, 일반공급 192세대)</txt-quarternary>
                    </v-col>
                </v-row>
            </sheet-tertiary>

            <div class="v-data-table v-data-table--border v-data-table--line v-data-table--density-comfortable mt-40px mt-md-60px">
                <div class="v-data-table__wrapper">
                    <table>
                        <thead>
                            <tr>
                                <th-primary rowspan="2">구분</th-primary>
                                <th-primary rowspan="2">주택<br />타입</th-primary>
                                <th-primary rowspan="2">공급<br />호수</th-primary>
                                <th-primary rowspan="2">특별<br />공급</th-primary>
                                <th-primary rowspan="2">일반<br />공급</th-primary>
                                <th-primary colspan="4">세대당 계약면적(㎡)</th-primary>
                                <th-primary rowspan="2">발코니<br />확장면적<br />(㎡)</th-primary>
                            </tr>
                            <tr>
                                <th-secondary class="border-r-white">주거전용</th-secondary>
                                <th-secondary class="border-r-white">주거공용</th-secondary>
                                <th-secondary class="border-r-white">기타공용<br /><span class="font-size-12 font-weight-regular">(*주차장 면적 포함)</span></th-secondary>
                                <th-secondary>합계</th-secondary>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-head-divider">
                                <th-secondary rowspan="2">청년형(1인)</th-secondary>
                                <td-primary>21</td-primary>
                                <td-primary>94</td-primary>
                                <td-primary>48</td-primary>
                                <td-primary>46</td-primary>
                                <td-primary>16.46</td-primary>
                                <td-primary>9.51</td-primary>
                                <td-primary>3.62</td-primary>
                                <td-primary>29.60</td-primary>
                                <td-primary>5.28</td-primary>
                            </tr>
                            <tr class="table-divider">
                                <td-primary>26</td-primary>
                                <td-primary>57</td-primary>
                                <td-primary>-</td-primary>
                                <td-primary>57</td-primary>
                                <td-primary>20.08</td-primary>
                                <td-primary>11.45</td-primary>
                                <td-primary>4.42</td-primary>
                                <td-primary>35.95</td-primary>
                                <td-primary>6.27</td-primary>
                            </tr>
                            <tr>
                                <th-secondary rowspan="3">신혼부부형<br />(예비신혼 포함)</th-secondary>
                                <td-primary>49</td-primary>
                                <td-primary>36</td-primary>
                                <td-primary>-</td-primary>
                                <td-primary>36</td-primary>
                                <td-primary>38.39</td-primary>
                                <td-primary>20.80</td-primary>
                                <td-primary>8.45</td-primary>
                                <td-primary>67.64</td-primary>
                                <td-primary>11.55</td-primary>
                            </tr>
                            <tr>
                                <td-primary>56</td-primary>
                                <td-primary>17</td-primary>
                                <td-primary>-</td-primary>
                                <td-primary>17</td-primary>
                                <td-primary>37.32</td-primary>
                                <td-primary>20.45</td-primary>
                                <td-primary>8.22</td-primary>
                                <td-primary>65.98</td-primary>
                                <td-primary>19.18</td-primary>
                            </tr>
                            <tr>
                                <td-primary>58</td-primary>
                                <td-primary>36</td-primary>
                                <td-primary>-</td-primary>
                                <td-primary>36</td-primary>
                                <td-primary>39.13</td-primary>
                                <td-primary>21.33</td-primary>
                                <td-primary>8.62</td-primary>
                                <td-primary>69.07</td-primary>
                                <td-primary>19.57</td-primary>
                            </tr>
                            <tr>
                                <th colspan="2" class="text-center">합계</th>
                                <td-primary>240</td-primary>
                                <td-primary>48</td-primary>
                                <td-primary>192</td-primary>
                                <td-primary></td-primary>
                                <td-primary></td-primary>
                                <td-primary></td-primary>
                                <td-primary></td-primary>
                                <td-primary></td-primary>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <sheet-primary class="mt-40px mt-lg-60px">
                <txt-quarternary class="grey--text text--lighten-1 line-height-17">
                    <v-row>
                        <template v-for="(item, index) in items">
                            <v-col :key="index" cols="12">
                                <p class="dot">
                                    {{ item }}
                                </p>
                            </v-col>
                        </template>
                    </v-row>
                </txt-quarternary>
            </sheet-primary>
        </page-section-primary>
    </app-primary>
</template>

<script>
import AppPrimary from "@/sets/parents/apps/app-primary.vue";
import SubHeadPrimary from "@/sets/parents/pages/sub-head-primary.vue";
import PageSectionPrimary from "@/sets/parents/pages/page-section-primary.vue";
import SheetPrimary from "@/components/publish/parents/sheets/sheet-primary.vue";
import SheetTertiary from "@/components/publish/parents/sheets/sheet-tertiary.vue";
import ChipPrimary from "@/components/publish/parents/chips/chip-primary.vue";
import TxtPrimary from "@/components/publish/parents/typography/txt-primary.vue";
import TxtQuarternary from "@/components/publish/parents/typography/txt-quarternary.vue";
import ThPrimary from "@/components/publish/parents/tables/th-primary.vue";
import ThSecondary from "@/components/publish/parents/tables/th-secondary.vue";
import TdPrimary from "@/components/publish/parents/tables/td-primary.vue";

export default {
    props: {},
    components: {
        AppPrimary,
        SubHeadPrimary,
        PageSectionPrimary,
        SheetPrimary,
        SheetTertiary,
        ChipPrimary,
        TxtPrimary,
        TxtQuarternary,
        ThPrimary,
        ThSecondary,
        TdPrimary,
    },
    data: () => ({
        items: [
            "본 주택은 공급유형별(청년, 신혼부부) 및 주택 타입별로 나뉘며, 청약 신청 시 공급유형별(청년 특별공급 및 일반공급, 신혼부부 특별공급 및 일반공급) 및 주택 타입별로 청약 접수가 진행되오니, 청약 신청 시 착오 없으시길 바랍니다.",

            "본 주택에 청약 시 특별공급과 일반공급 중 주택형(타입) 별로 1건만 가능하며, 신혼부부(예비신혼부부 포함)는 1세대로 간주하여 부부(예비부부) 중 1명이 대표로 1건만 신청이 가능하고, 두 명이 각각 중복 신청할 경우에는 전부 무효 처리됩니다.",

            "본 주택은 인터넷 청약 시, 주거전용(타입)별로 구분되어 청약접수가 진행되오니, 청약 신청 시 착오 없으시길 바랍니다.",
            "청약에 적용되는 주택형(타입) 명은 사업계획승인도서(건축허가) 도서에 표기된 주택형(타입) 명과 다를 수 있습니다.",

            "주거전용면적은 주거의 용도로만 쓰이는 면적이며, 주거공용면적은 계단, 복도, 공동현관 등 공동주택의 공용면적입니다. 또한 그 밖의 공용면적은 공급면적을 제외한 공용면적으로, 관리사무소, 경비실, 주민공동시설, 기계·전기실 등이 포함되며, 상기 계약면적에는 위에 설명 드린 주거전용면적, 주거공용면적, 기타공용면적, 지하주차장 등의 면적이 포함되어 있습니다.",

            "「건축물의 면적 높이 등의 세부 산정 기준」 등과 기타 관련 법령 및 규정에 따라 엘리베이터(E/V)실, 설비배관실(PD), 배연설비시설, 급기실(A/D), 전기통신실(EPS/TPS) 등은 면적산정에서 제외되어 있습니다.",

            "본 주택은 주거목적 외 다른 목적으로 사용이 불가하며, 상기 타입별 공급면적 및 대지면적은 사용승인(준공) 시 건축법 제26조(허용 오차) 및 같은 법 시행규칙 제20조(허용오차)에 따른 허용오차 범위 내 일부 변경될 수 있습니다. 변경된 면적은 임대료 및 관리비에 영향을 줄 수 있습니다.",

            "세대 내 민간 가정 어린이집을 운영할 목적으로 청약신청 및 계약은 불가하고, 입주자모집 공고문 미확인으로 인하여 발생하는 불이익은 계약자 본인에게 그 책임이 있으며 당사에서 책임지지 않습니다.",

            "상기 공급호수는 공공지원민간임대주택에 해당하며 공공임대주택분은 포함되지 않습니다.",

            "모든 주택타입은 발코니 확장공사를 진행하여 공급될 예정이며,실제 사용하게 되는 면적은 상기 주거전용면적보다 늘어나게 됩니다.",

            "관리비는 계약 면적으로 부과됩니다.",
            //
        ],
    }),
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
